import * as fireAuth from "firebase/auth";
import { App } from "./App";

export function addDebugHooks(app: App) {
  const win = window as any;
  win.fireAuth = fireAuth;
  win.app = app;
}
